import Vue from 'vue'
import axios from 'axios';
import VueRouter from 'vue-router';
import App from './App.vue'
import store from './store'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
import { LayoutPlugin } from 'bootstrap-vue';
Vue.use(LayoutPlugin)
import slVueTree from 'sl-vue-tree'
import './assets/css/gdq_web.css';
import './assets/css/gdqfont.css';
import './assets/custom.scss';
// ------------------
// Fontawesome Icons
// ------------------
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon';
Vue.component('fa-icon', Icon)
// ------------
// Folder Tree
// ------------
Vue.component('sl-vue-tree', slVueTree)

import GDQAdmin from './components/GDQAdmin';

Vue.config.productionTip = false

//-------
// Routes 
//------- 
import routes from './routes';

Vue.config.productionTip = false;
const accessToken = localStorage.getItem('gdq_atoken');
if (accessToken) {
  axios.defaults.headers.common['Authorization'] = accessToken
}

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: routes,
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      store.dispatch('setrouteafterlogin', '')
      next()
      return
    }
    store.dispatch('setrouteafterlogin', to === '/login' ? '' : to);
    next('/login')
  } else {
    next()
  }
})

new Vue({
  el: '#app',
  components: {
    App,
    GDQAdmin,
  },
  template: '<App/>',
  router,
  store,
  render: h => h(App)
})
